import { supabase } from '../lib/supabase';

export interface OrderItem {
  name: string;
  price: number;
  quantity: number;
  image?: string;
}

export interface OrderCustomerData {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  address?: string;
  company?: string;
  order_comment?: string;
  payment_method?: string;
  shipping_method?: string;
  items?: OrderItem[];
  total?: number;
}

export interface Order {
  id: string;
  user_id: string | null;
  esto_reference: string | null;
  amount: number;
  status: string;
  created_at: string;
  updated_at: string;
  marketing_consent: boolean;
  customer_data: OrderCustomerData;
}

/** Human-facing order reference used in emails and the UI. */
export function orderReference(order: Order): string {
  return order.esto_reference || order.id.slice(0, 8).toUpperCase();
}

export async function fetchAllOrders(): Promise<Order[]> {
  const { data, error } = await supabase
    .from('orders')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;

  return (data || []).map((o: any) => ({
    ...o,
    amount: Number(o.amount) || 0,
    customer_data: o.customer_data || {},
  })) as Order[];
}

export async function updateOrder(
  id: string,
  updates: { status?: string; amount?: number; customer_data?: OrderCustomerData; marketing_consent?: boolean }
): Promise<void> {
  const { error } = await supabase
    .from('orders')
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', id);

  if (error) throw error;
}

export async function deleteOrder(id: string): Promise<void> {
  const { error } = await supabase.from('orders').delete().eq('id', id);
  if (error) throw error;
}
